module.exports = __webpack_public_path__ + "konto_active.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/konto_active.svg
// module id = 114
// module chunks = 0